const BROWSER_UPDATE_URLS = {
	chrome: 'https://www.google.com/chrome/',
	edge: 'https://www.microsoft.com/edge',
	firefox: 'https://www.mozilla.org/firefox/new/',
	opera: 'https://www.opera.com/download',
	safari: 'https://support.apple.com/en-us/102665',
	samsung: 'https://www.samsung.com/global/galaxy/apps/samsung-internet/',
	ie: 'https://www.microsoft.com/edge',
};

const BROWSER_TITLES = {
	chrome: 'Google Chrome',
	edge: 'Microsoft Edge',
	firefox: 'Mozilla Firefox',
	opera: 'Opera',
	safari: 'Safari',
	samsung: 'Samsung Internet',
	ie: 'Internet Explorer',
};

const MIN_BROWSER_VERSIONS = {
	chrome: 120,
	edge: 120,
	firefox: 115,
	opera: 106,
	safari: 16,
	samsung: 21,
	ie: 999,
};

const toMajorVersion = (value) => {
	var parsed = parseInt(value, 10);
	return Number.isFinite(parsed) ? parsed : null;
};

export const parseBrowserInfo = (userAgent) => {
	if (!userAgent || typeof userAgent !== 'string') {
		return null;
	}

	var ua = userAgent;
	var match = null;

	match = ua.match(/(?:MSIE |Trident\/.*rv:)(\d+)/i);
	if (match) {
		return { id: 'ie', majorVersion: toMajorVersion(match[1]) };
	}

	match = ua.match(/Edg\/(\d+)/i);
	if (match) {
		return { id: 'edge', majorVersion: toMajorVersion(match[1]) };
	}

	match = ua.match(/OPR\/(\d+)/i);
	if (match) {
		return { id: 'opera', majorVersion: toMajorVersion(match[1]) };
	}

	match = ua.match(/SamsungBrowser\/(\d+)/i);
	if (match) {
		return { id: 'samsung', majorVersion: toMajorVersion(match[1]) };
	}

	match = ua.match(/(?:Chrome|CriOS)\/(\d+)/i);
	if (match) {
		return { id: 'chrome', majorVersion: toMajorVersion(match[1]) };
	}

	match = ua.match(/(?:Firefox|FxiOS)\/(\d+)/i);
	if (match) {
		return { id: 'firefox', majorVersion: toMajorVersion(match[1]) };
	}

	match = ua.match(/Version\/(\d+).+Safari/i);
	if (match && !/Chrome|CriOS|Edg|OPR/i.test(ua)) {
		return { id: 'safari', majorVersion: toMajorVersion(match[1]) };
	}

	return null;
};

export const getOutdatedBrowserWarning = (navigatorLike) => {
	var nav = navigatorLike || (typeof window !== 'undefined' ? window.navigator : null);
	var userAgent = nav && nav.userAgent;
	var browser = parseBrowserInfo(userAgent);

	if (!browser || browser.majorVersion == null) {
		return null;
	}

	var minSupportedVersion = MIN_BROWSER_VERSIONS[browser.id];
	if (!Number.isFinite(minSupportedVersion)) {
		return null;
	}

	if (browser.majorVersion >= minSupportedVersion) {
		return null;
	}

	return {
		browserId: browser.id,
		browserName: BROWSER_TITLES[browser.id] || 'Браузер',
		currentVersion: browser.majorVersion,
		minSupportedVersion: minSupportedVersion,
		updateUrl: BROWSER_UPDATE_URLS[browser.id] || BROWSER_UPDATE_URLS.chrome,
	};
};
